export default {
    namespaced: true,
    state: {
        token: false,
        msg: "本站需要身份验证后才能进入哦!"
    },
    getters: {
        token(state){
            return state.token
        },
        msg(state){
            return state.msg
        }
    },
    mutations: {
        //登录
        LOGIN(state,value){
            localStorage.setItem("time",JSON.stringify(value))
            state.token = true
        },
        //初始化
        INIT(state){
            const data = JSON.parse(localStorage.getItem("time"))
            if(data === null){
                state.msg = "本站需要身份验证后才能进入哦!"
            }else{
                const now = new Date().getTime()
                if(now > data.expire){
                    localStorage.removeItem("time")
                    state.token = false
                    state.msg = "身份验证已过期,请重新登录"
                }else{
                    state.token = true
                }
            }
        }
    }
}